export var appStatusColors = {
  productive: "#2ECC71",
  neutral: "#BDC3C7",
  unproductive: "#E74C3C"
};